        // custom-code
// let countTimer = null;
// let intervalTimer = null;

// function updateVariantCount() {
//   const items = document.querySelectorAll('.custom-code-filter li');

//   let inCount = 0;
//   let outCount = 0;

//   items.forEach(item => {
//     if (item.classList.contains('variant-in')) {
//       inCount++;
//     } else if (item.classList.contains('variant-out')) {
//       outCount++;
//     }
//   });

//   const inStockSpan = document.querySelector('.count_in_sto');
//   const outStockSpan = document.querySelector('.count_out_sto');

//   const inStockSpan1 = document.querySelector('.insto');
//   const outStockSpan1 = document.querySelector('.otsto');

//   const inStockSpan2 = document.querySelector('.cut-in');
//   const outStockSpan2 = document.querySelector('.cut-out');

//   if (inStockSpan) inStockSpan.textContent = inCount;
//   if (outStockSpan) outStockSpan.textContent = outCount;
//   if (inStockSpan1) inStockSpan1.textContent = inCount;
//   if (outStockSpan1) outStockSpan1.textContent = outCount;
//   if (inStockSpan2) inStockSpan2.textContent = inCount;
//   if (outStockSpan2) outStockSpan2.textContent = outCount;

//   console.log('IN:', inCount, 'OUT:', outCount);
//   if (inCount > 0 || outCount > 0) {
//     clearInterval(intervalTimer);
//     intervalTimer = null;
//   }
// }

// function debouncedUpdate() {
//   clearTimeout(countTimer);
//   countTimer = setTimeout(updateVariantCount, 100);
// }
// document.addEventListener('DOMContentLoaded', () => {
//   updateVariantCount();
//   intervalTimer = setInterval(updateVariantCount, 500);
// });
// const grid = document.getElementById('product-grid');

// if (grid) {
//   const observer = new MutationObserver(debouncedUpdate);
//   observer.observe(grid, {
//     childList: true,
//     subtree: true,
//     attributes: true,
//     attributeFilter: ['class']
//   });
// }

// function updateVariantCount111() {
//   requestAnimationFrame(() => {
//     setTimeout(() => {
//       const items = document.querySelectorAll('.custom-code-filter li');

//       let inCount = 0;
//       let outCount = 0;

//       items.forEach(item => {
//         if (item.classList.contains('variant-in')) inCount++;
//         if (item.classList.contains('variant-out')) outCount++;
//       });

//       const inStockSpan = document.querySelector('.count_in_sto');
//       const outStockSpan = document.querySelector('.count_out_sto');

//       const inStockSpan1 = document.querySelector('.insto');
//       const outStockSpan1 = document.querySelector('.otsto');

//       const inStockSpan2 = document.querySelector('.cut-in');
//       const outStockSpan2 = document.querySelector('.cut-out');

//       if (inStockSpan) inStockSpan.textContent = inCount;
//       if (outStockSpan) outStockSpan.textContent = outCount;
//       if (inStockSpan1) inStockSpan1.textContent = inCount;
//       if (outStockSpan1) outStockSpan1.textContent = outCount;
//       if (inStockSpan2) inStockSpan2.textContent = inCount;
//       if (outStockSpan2) outStockSpan2.textContent = outCount;

//       console.log('UPDATED → IN:', inCount, 'OUT:', outCount);

//       // --- Only hide load more if there is NO next page ---
//       const nextUrlDiv = document.getElementById('paginateNext');
//       const loadmore = document.querySelector('.more_btn_hide');

//       if (nextUrlDiv && !nextUrlDiv.getAttribute('data-next-url')) {
//         loadmore.style.display = 'none';
//       } else {
//         loadmore.style.display = 'block';
//       }

//     }, 200); // smaller timeout is enough
//   });
// }


// function clearitems() {
// window.location.reload();
// }


// --------------------
// VARIANT COUNT & STOCK FILTERS
// --------------------

let countTimer = null;
let intervalTimer = null;

// Update stock counts in all relevant spans
function updateStockCounts() {
  const items = document.querySelectorAll('.custom-code-filter li');
  let inCount = 0, outCount = 0;

  items.forEach(item => {
    if (item.classList.contains('variant-in')) inCount++;
    if (item.classList.contains('variant-out')) outCount++;
  });

  // Update all spans automatically
  const inSpans = document.querySelectorAll('.count_in_sto, .insto, .cut-in');
  const outSpans = document.querySelectorAll('.count_out_sto, .otsto, .cut-out');

  inSpans.forEach(span => span.textContent = inCount);
  outSpans.forEach(span => span.textContent = outCount);

  console.log('Stock counts → IN:', inCount, 'OUT:', outCount);

  // Handle Load More visibility
  const loadMoreBtn = document.querySelector('.more_btn_hide');
  const nextUrlDiv = document.getElementById('paginateNext');

  if (loadMoreBtn) {
    loadMoreBtn.style.display = (nextUrlDiv && nextUrlDiv.getAttribute('data-next-url')) ? 'block' : 'none';
  }
}

// Debounce for AJAX / DOM changes
function debouncedUpdateStockCounts() {
  clearTimeout(countTimer);
  countTimer = setTimeout(updateStockCounts, 100);
}

// Initial stock counts + interval for delayed DOM updates
document.addEventListener('DOMContentLoaded', () => {
  updateStockCounts();
  intervalTimer = setInterval(updateStockCounts, 500);
});

// Observe product grid for AJAX changes
const grid = document.getElementById('product-grid');
if (grid) {
  const observer = new MutationObserver(debouncedUpdateStockCounts);
  observer.observe(grid, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
}

// --------------------
// CLEAR BUTTONS
// --------------------
function attachClearStockButtons() {
  const buttons = document.querySelectorAll('.In_stock_main, .Out_of_stock_main, .In_stock_main1, .Out_of_stock_main1');
  const radios = document.querySelectorAll('input[name="variant"]');

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const type = btn.className.includes('In_stock') ? 'in_stock' : 'out_stock';
      
      // Remove body class
      document.body.classList.remove(type === 'in_stock' ? 'instock' : 'outstock');

      // Uncheck radios
      radios.forEach(r => { if (r.value === type) r.checked = false; });

      // Remove variant from URL
      const url = new URL(window.location.href);
      if (url.searchParams.get('variant') === type) {
        url.searchParams.delete('variant');
        window.history.replaceState({}, '', url);
      }

      // Re-render page via AJAX if facet-filters-form exists
      const form = document.querySelector('facet-filters-form');
      if (form) {
        form.onSubmitForm(url.searchParams.toString());
      } else {
        window.location.reload();
      }
    });
  });
}

// Call once on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => attachClearStockButtons());

// Re-attach clear buttons if DOM changes dynamically
const bodyObserver = new MutationObserver(attachClearStockButtons);
bodyObserver.observe(document.body, { childList: true, subtree: true });

// --------------------
// RADIO FILTERS
// --------------------
document.addEventListener('DOMContentLoaded', () => {
  const radios = document.querySelectorAll('input[name="variant"]');
  const loadmore = document.querySelector('.more_btn_hide');

  radios.forEach(radio => {
    radio.addEventListener('change', () => {
      const value = radio.value;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', value);
      window.history.replaceState({}, '', url);

      document.body.classList.remove('instock', 'outstock');
      if (value === 'in_stock') document.body.classList.add('instock');
      if (value === 'out_stock') document.body.classList.add('outstock');

      if (loadmore) loadmore.style.display = 'none';

      // Trigger AJAX filter if exists
      const form = document.querySelector('facet-filters-form');
      if (form) form.onSubmitForm(url.searchParams.toString());
    });
  });
});


 // custom-code

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    console.log('Ahat');
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      console.log(url);
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
  const container = document.getElementById('product-grid');
  const items = container.querySelectorAll('.custom-code-filter li');
  const loadMoreBtn = document.querySelector('.more_btn_hide');
  const nextUrlDiv = document.getElementById('paginateNext');

  let visibleCount = 0;

  items.forEach((item) => {
    const showItem =
      (document.body.classList.contains('instock') && item.classList.contains('variant-in')) ||
      (document.body.classList.contains('outstock') && item.classList.contains('variant-out')) ||
      (!document.body.classList.contains('instock') && !document.body.classList.contains('outstock'));

    item.style.display = showItem ? 'block' : 'none';

    if (showItem) visibleCount++;
  });

  if (nextUrlDiv && !nextUrlDiv.getAttribute('data-next-url')) {
    loadMoreBtn.style.display = 'none';
  } else {
    loadMoreBtn.style.display = 'block';
  }

  updateStockCounts();
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document.getElementById('ProductGridContainer').querySelectorAll('.scroll-trigger').forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    // updateVariantCount()
    // updateVariantCount111()
    updateStockCounts()
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
      
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


// custom-code

document.addEventListener('DOMContentLoaded', () => {
  const radios = document.querySelectorAll('input[name="variant"]');
  const loadmore = document.querySelector('.more_btn_hide');

  // Radio change logic same as before...
  radios.forEach(radio => {
    radio.addEventListener('change', () => {
      const value = radio.value;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', value);
      window.history.replaceState({}, '', url);
      updateBodyClass(value);
      loadmore.style.display = 'none';
    });
  });

  // --- Clear buttons ---
  function attachClearButtons() {
    const clearInStock = document.querySelector('.In_stock_main');
    const clearOutStock = document.querySelector('.Out_of_stock_main');
    const clearInStock1 = document.querySelector('.In_stock_main1');
    const clearOutStock1 = document.querySelector('.Out_of_stock_main1');

    if (clearInStock) {
      clearInStock.addEventListener('click', () => {
        document.body.classList.remove('instock');
        radios.forEach(r => { if (r.value === 'in_stock') r.checked = false; });
        const url = new URL(window.location.href);
        if (url.searchParams.get('variant') === 'in_stock') {
          url.searchParams.delete('variant');
          window.history.replaceState({}, '', url);
          clearitems();
        }
      });
    }

    if (clearOutStock) {
      clearOutStock.addEventListener('click', () => {
        document.body.classList.remove('outstock');
        radios.forEach(r => { if (r.value === 'out_stock') r.checked = false; });
        const url = new URL(window.location.href);
        if (url.searchParams.get('variant') === 'out_stock') {
          url.searchParams.delete('variant');
          window.history.replaceState({}, '', url);
          clearitems();
        }
      });
    }
    if (clearInStock1) {
      clearInStock1.addEventListener('click', () => {
        document.body.classList.remove('instock');
        radios.forEach(r => { if (r.value === 'in_stock') r.checked = false; });
        const url = new URL(window.location.href);
        if (url.searchParams.get('variant') === 'in_stock') {
          url.searchParams.delete('variant');
          window.history.replaceState({}, '', url);
          clearitems();
        }
      });
    }

    if (clearOutStock1) {
      clearOutStock1.addEventListener('click', () => {
        document.body.classList.remove('outstock');
        radios.forEach(r => { if (r.value === 'out_stock') r.checked = false; });
        const url = new URL(window.location.href);
        if (url.searchParams.get('variant') === 'out_stock') {
          url.searchParams.delete('variant');
          window.history.replaceState({}, '', url);
          clearitems();
        }
      });
    }

  }

  // Call once immediately
  attachClearButtons();

  // Optional: re-attach if DOM changes dynamically (Shopify / AJAX)
  const observer = new MutationObserver(() => attachClearButtons());
  observer.observe(document.body, { childList: true, subtree: true });
});

function updateBodyClass(value) {
  document.body.classList.remove('instock', 'outstock');
  if (value === 'in_stock') document.body.classList.add('instock');
  if (value === 'out_stock') document.body.classList.add('outstock');
}

// custom-code